import React from "react";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { Spinner } from "reactstrap";
import { useRecoilValue } from "recoil";
import { uploadingFile } from "src/recoil/atoms/global";
import { getFileName } from "src/utils/common";
import "../../../scss/custom/page/_flight-simulator.scss";
import { useTranslation } from "react-i18next";
import { FORM_NAME } from "../Modal/ModalUploadFile6DOF";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const ParamsInput6DoFTableItem = ({ file, index, name }) => {
  return (
    <div className="card mb-0 shadow-none border" key={index}>
      <div
        className={classNames("p-2 d-flex align-items-center height-by-px-48", {
          "justify-content-between": file,
          "justify-content-center": !file,
        })}
      >
        {file ? (
          <TooltipWrapper
            tooltipText={file?.name ? getFileName(file?.name) : getFileName(file)}
            id={`file-table-item-${name}-${index}`}
            checkOverflow={true}
          >
            <p className="text-muted fw-bold fs-15 mb-0 text-truncate important-width-by-px-216">
              {file?.name ? getFileName(file?.name) : getFileName(file)}
            </p>
          </TooltipWrapper>
        ) : (
          <span className="d-block text-center fs-2 fw-normal">-</span>
        )}
      </div>
    </div>
  );
};

const ParamsInput6DoFTable = ({ paramsInput, setConfirmDelete, setItemDelete }) => {
  const globalUploadingField = useRecoilValue(uploadingFile);
  const { t } = useTranslation("flight-simulator");
  const HEADER_TITLES = [
    `${t("new.parameter_json")} json`,
    `${t("new.mass_and_shape_response")} json`,
    `${t("new.aero_coefficients_ascent")}`,
    `${t("new.aero_coefficients_ascent_2")}`,
    `${t("new.aero_coefficients_descent")}`,
    `${t("new.wind_model")}`,
    `${t("new.thrust_profile")}`,
    `${t("new.target_attitude_rate_ascent")}`,
    `${t("new.target_attitude_rate_descent")}`,
    `${t("new.target_attitude_ascent")}`,
    `${t("new.target_attitude_descent")}`,
  ];

  return (
    <div
      className={classNames("table-responsive border mb-3 p-t-12 p-x-12 p-b-12", {
        "p-b-22": isEmpty(paramsInput),
      })}
    >
      {globalUploadingField ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner color="secondary" />
        </div>
      ) : (
        <table className="table mb-0 params-input-6dof-table">
          <thead>
            <tr>
              {HEADER_TITLES.map((title, index) => (
                <th key={index} className="border-0 text-nowrap important-p-t-10 important-p-x-10 important-p-b-0">
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!isEmpty(paramsInput) &&
              paramsInput?.map((param, index) => (
                <tr key={index}>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <div className="card mb-0 shadow-none border">
                      <div className="p-2 d-flex align-items-center height-by-px-48">
                        <div className="me-2 d-flex align-items-center">
                          <i
                            className="bi bi-trash text-danger f-s-24 user-select-pointer"
                            role="button"
                            onClick={() => {
                              setItemDelete(index);
                              setConfirmDelete(true);
                            }}
                          />
                        </div>
                        <div className="d-flex align-items-center">
                          <TooltipWrapper
                            tooltipText={
                              param?.[FORM_NAME.PARAMETER_JSON]?.name
                                ? getFileName(param?.[FORM_NAME.PARAMETER_JSON]?.name)
                                : getFileName(param?.[FORM_NAME.PARAMETER_JSON])
                            }
                            id={`file-${FORM_NAME.PARAMETER_JSON}-${index}`}
                            checkOverflow={true}
                          >
                            <p className="text-muted fw-bold fs-15 mb-0 text-truncate important-width-by-px-180">
                              {param?.[FORM_NAME.PARAMETER_JSON]?.name
                                ? getFileName(param?.[FORM_NAME.PARAMETER_JSON]?.name)
                                : getFileName(param?.[FORM_NAME.PARAMETER_JSON])}
                            </p>
                          </TooltipWrapper>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.MASS_AND_SHAPE_RESPONSE]}
                      index={index}
                      name={FORM_NAME.MASS_AND_SHAPE_RESPONSE}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.AERO_COEFFICIENTS_ASCENT]}
                      index={index}
                      name={FORM_NAME.AERO_COEFFICIENTS_ASCENT}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.AERO_COEFFICIENTS_ASCENT_2]}
                      index={index}
                      name={FORM_NAME.AERO_COEFFICIENTS_ASCENT_2}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.AERO_COEFFICIENTS_DESCENT]}
                      index={index}
                      name={FORM_NAME.AERO_COEFFICIENTS_DESCENT}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem file={param?.[FORM_NAME.WIND_MODEL]} index={index} name={FORM_NAME.WIND_MODEL} />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem file={param?.[FORM_NAME.THRUST_PROFILE]} index={index} name={FORM_NAME.THRUST_PROFILE} />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.TARGET_ATTITUDE_RATE_ASCENT]}
                      index={index}
                      name={FORM_NAME.TARGET_ATTITUDE_RATE_ASCENT}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.TARGET_ATTITUDE_RATE_DESCENT]}
                      index={index}
                      name={FORM_NAME.TARGET_ATTITUDE_RATE_DESCENT}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.TARGET_ATTITUDE_ASCENT]}
                      index={index}
                      name={FORM_NAME.TARGET_ATTITUDE_ASCENT}
                    />
                  </td>
                  <td className="border-0 min-width-by-px-264 important-p-a-10">
                    <ParamsInput6DoFTableItem
                      file={param?.[FORM_NAME.TARGET_ATTITUDE_DESCENT]}
                      index={index}
                      name={FORM_NAME.TARGET_ATTITUDE_DESCENT}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ParamsInput6DoFTable;
